import React, { useEffect } from 'react';
import { Column } from '@ant-design/plots';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import { registerChart, unregisterChart } from '../../../../../../../../utils/chartRegistry';

const CHART_ID = 'benchmark-bar-chart';

const BenchmarkBarChart = (props) => {
    // Drop the registered instance on unmount so the PDF export never resizes a
    // stale chart.
    useEffect(() => () => unregisterChart(CHART_ID), []);
    let data = props.fetchTotalFeedbackProvidersStrengthAndDevApi.data && props.fetchTotalFeedbackProvidersStrengthAndDevApi.data.data ? props.fetchTotalFeedbackProvidersStrengthAndDevApi.data.data : []
    const categories = [...new Set(data.map(i => i.category))];
    const isSingleCategory = categories.length === 1;
    const config = {
        data,
        height: 400,
        // Render as SVG (not the default canvas) so this chart is real DOM and
        // survives the innerHTML snapshot used by the PDF export (PdfPreviewModal).
        // Every other Benchmark chart is already inline SVG; this keeps them consistent.
        renderer: 'svg',
        xField: 'category',
        yField: 'value',
        // isGroup: true,
        seriesField: 'metric',

        columnWidthRatio: 0.4,
        dodgePadding: isSingleCategory ? undefined : 8,
        maxColumnWidth: 40,
        columnStyle: {
            radius: [4, 4, 0, 0],
        },

        color: ['#f2823b'],

        yAxis: {
            label: null,
            line: null,
            tickLine: null,
            grid: {
                line: {
                    style: {
                        stroke: '#eef0f2',
                        lineWidth: 1,
                    },
                },
            },
        },

        xAxis: {
            label: {

                autoRotate: false,
                formatter: (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text),
            },
            grid: null,
        },

        padding: [70, 24, 48, 48],

        legend: {

            flipPage: false,
            maxRow: 1,
            itemSpacing: 20,
            maxItemWidth: 400,
            marker: {
                // Rounded square: G2 has no built-in one, so draw a rounded-rect path.
                symbol: (x, y, r) => {
                    const c = r * 0.5; // corner radius
                    const left = x - r;
                    const right = x + r;
                    const top = y - r;
                    const bottom = y + r;
                    return [
                        ['M', left + c, top],
                        ['L', right - c, top],
                        ['A', c, c, 0, 0, 1, right, top + c],
                        ['L', right, bottom - c],
                        ['A', c, c, 0, 0, 1, right - c, bottom],
                        ['L', left + c, bottom],
                        ['A', c, c, 0, 0, 1, left, bottom - c],
                        ['L', left, top + c],
                        ['A', c, c, 0, 0, 1, left + c, top],
                        ['Z'],
                    ];
                },
                style: {
                    r: 8,
                },
            },
            itemName: {
                formatter: (text) => {
                    if (text === 'Development Areas')
                        return '% of Feedback Providers that provided Development Areas';
                },
                style: {
                    fontSize: 14,

                    color: "#5b646f"
                },
            },
        },

        label: {
            position: 'top',
            offsetY: 10,
            formatter: (item) => `${item.value}%`,
            style: {
                fill: '#333',
                fontWeight: 600,
                fontSize: 12,
            },
        },

        tooltip: false,

        responsive: true,

        interactions: [
            { type: 'tooltip', enable: false },
            { type: 'active-region', enable: false },
            { type: 'element-active', enable: false },
            { type: 'element-highlight', enable: false },
            { type: 'element-selected', enable: false },
            { type: 'legend-filter', enable: false },
            { type: 'legend-highlight', enable: false },
        ],
    };


    return (
        <AsyncSection api={props.fetchTotalFeedbackProvidersStrengthAndDevApi} loaderHeight={300} loaderWidth={600}>
            <div className='cardwrapper'>
                <h3>% of respondents providing development areas</h3>
                <p className='description-container'>Nearly every respondent provides strengths, so the signal is in the development-areas share: how willing each group is to name what needs to change.</p>
                <div id={CHART_ID}>
                    <Column {...config} onReady={(plot) => registerChart(CHART_ID, plot)} />
                </div>
            </div>
        </AsyncSection>
    );
};

export default BenchmarkBarChart;
